import Product from '../product';
import Material from '../../material/material';
import BoardPart from './board-part';
import BoardPrintType from './board-print-type';
import BoardConstructionMaterial from './board-construction-materials';
import { CollectionHelper } from 'src/app/helpers/collection-helper';

export default class Board extends Product {
  boardPrintType?: BoardPrintType;
  boardPrintAlternative?: string;
  tilingFormats?: string;
  placeInstructions?: string;
  distanceFrontPostToStreet?: string;
  boardParts?: BoardPart[];
  boardConstructionMaterials?: BoardConstructionMaterial[];

  // Display only
  atLeastOneStandardPart?: boolean;
  calculatedAggregatePrice?: any;
  calculatedPaintedPostsPrice?: any;

  constructor() {
    super();
    this.type = 'Board';
  }

  // Override
  public canSubmitAsClient(): boolean {
    return (
      CollectionHelper.isPopulated(this.boardParts) &&
      this.boardParts.every(bp => bp.canSubmitAsClient())
    );
  }
}

export const MaterialChoices = {
  ALUCOBOND: new Material('Alucobond 3mm', 15),
  XPRINT: new Material('X-print', 17),
  PVC: new Material('PVC', 18),
  DUOPROP: new Material('Duoprop', 19),
  UNSPECIFIED: new Material('Andere', 16)
};

export const MaterialChoicesArray = Object.values(MaterialChoices);

export const BoardPrintTypeChoices = {
  DIRECTLY_PRINTED: new BoardPrintType('Rechtstreeks bedrukt', 0),
  UNSPECIFIED: new BoardPrintType('Andere', 1)
};

export const BoardPrintTypeChoicesArray = Object.values(BoardPrintTypeChoices);
